import { DateRange, DateTime } from '@ksyos/date-time';

export function dateRangesHaveOverlap<T extends { endDate: Date | string | null; startDate: Date | string }>(
    items: T[]
) {
    const dateRanges = items.map(
        (dateRange) =>
            new DateRange(
                DateTime.from(dateRange.startDate),
                dateRange.endDate ? DateTime.from(dateRange.endDate) : null
            )
    );

    for (const rangeToValidate of dateRanges) {
        const hasOverlap = dateRanges.some(
            (otherRange) => rangeToValidate !== otherRange && rangeToValidate.hasOverlapWith(otherRange)
        );

        if (hasOverlap) {
            return true;
        }
    }

    return false;
}
